export default __webpack_public_path__ + "a7a925c7c07f163f3274df0c1ab2c321.svg";